module.exports = __webpack_public_path__ + "img/horizontal_6_3_pp3_5012.1cc0aa97.png";